const css = `.YBHLmW__segmentFollow{cursor:pointer}.YBHLmW__notificationsContainer svg{transition:transform .2s}.YBHLmW__notificationsContainer:hover svg{transform:rotate(-15deg)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"segmentFollow":"YBHLmW__segmentFollow","notificationsContainer":"YBHLmW__notificationsContainer"};
